module.exports = __webpack_public_path__ + "static/img/game-icon0.1401fba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/game-icon0.png
// module id = /s8F
// module chunks = 0